import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ComposerErrorOverlay = () => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "error",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'composer-ui.capability-editor.error.loading-capabilities'
    })
  });
};
ComposerErrorOverlay.displayName = 'ComposerLoadingOverlay';
export default ComposerErrorOverlay;